module.exports = __webpack_public_path__ + "static/media/active-minutes-video.f028fca0.mp4";